// Formateadores puros. Sin dependencias del DOM ni de Supabase — deben poder
// usarse igual desde cualquiera de las 3 apps (y, a futuro, desde un script
// de Node) sin arrastrar nada del navegador.

/**
 * Formatea un monto en la moneda de la plataforma (soles peruanos por
 * defecto — ver `empresa.moneda` en el diseño de base de datos, 5.2).
 *
 * @param {number} valor
 * @param {string} [moneda] Código ISO 4217. Por defecto 'PEN'.
 * @returns {string} ej. "S/ 30.00"
 */
export function formatearMoneda(valor, moneda = 'PEN') {
  const formateado = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: moneda,
    minimumFractionDigits: 2,
  }).format(valor);

  // ICU inserta un espacio NO separable (U+00A0, a veces U+202F) entre el
  // símbolo y el número — visualmente idéntico a un espacio normal, pero
  // distinto byte a byte. Se normaliza a espacio común: si no, el mismo
  // formato sale distinto según la plataforma/versión de ICU (así se
  // detectó: pasaba en Linux/CI y fallaba en Windows), y cualquier
  // comparación exacta de string (tests, snapshots) se vuelve fragil.
  return formateado.replace(/[\u00A0\u202F]/g, ' ');
}

function esFechaValida(fecha) {
  return fecha !== null && fecha !== undefined && fecha !== '';
}

/**
 * Formatea una fecha (o timestamp) en formato corto legible para Perú.
 *
 * @param {string | Date | null | undefined} fecha
 * @returns {string} ej. "21 jul. 2026"
 */
export function formatearFecha(fecha) {
  if (!esFechaValida(fecha)) return '—';
  const d = fecha instanceof Date ? fecha : new Date(fecha);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('es-PE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'America/Lima',
  }).format(d);
}

/**
 * Igual que `formatearFecha` pero incluyendo hora — usada en tablas donde
 * el orden cronológico dentro del mismo día importa (logs, publicaciones).
 *
 * @param {string | Date | null | undefined} fecha
 * @returns {string} ej. "21 jul. 2026, 3:45 p. m."
 */
export function formatearFechaHora(fecha) {
  if (!esFechaValida(fecha)) return '—';
  const d = fecha instanceof Date ? fecha : new Date(fecha);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('es-PE', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'America/Lima',
  }).format(d);
}
